import React from "react";
import "./ScreenshotProtection.css";

const ScreenshotBlockOverlay = ({
  isVisible,
  title = "Screenshots are not allowed",
  message = "Protected content is temporarily hidden.",
  onClose,
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      className="screenshot-overlay"
      role="dialog"
      aria-live="polite"
      aria-modal="true"
      aria-label="Screenshot protection notice"
      onClick={onClose}
    >
      <div className="screenshot-overlay-card" onClick={(event) => event.stopPropagation()}>
        <div className="screenshot-overlay-icon" aria-hidden="true">
          !
        </div>
        <h2>{title}</h2>
        <p>{message}</p>
        <button
          type="button"
          className="screenshot-overlay-dismiss"
          onMouseDown={onClose}
          onTouchStart={onClose}
          onClick={onClose}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
};

export default ScreenshotBlockOverlay;
